import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar/Navbar";
import axiosInstance from './utils/axiosInstance';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Home from "./pages/";
import Login from "./pages/login";
import Search from "./pages/search";
import Taxpayer from "./pages/taxpayer";
import Logout from "./pages/logout";
import TwoFactor from "./pages/twoFactor";
import Admin from "./pages/admin"
import PreviousClients from "./pages/previousClients"
import './App.css';

 
function App() {
    const [isLoading, setLoading] = useState(null);
    const [authenticatedUser, setAuthenticatedUser] = useState(null);
    const [isAdmin, setAdmin] = useState(false);

    useEffect(() => {
        setLoading(true)
        const getInitialUserState = async() => {
            //setAuthenticatedUser("")
            await axiosInstance.get('/checkSession', {withCredentials:true} )
            .then(response => {
                setAuthenticatedUser(response.data.username)
            })
            .catch(error => {
                setAuthenticatedUser(false);
                console.log(error)
            });
        };
    
        const getAdminState = async() => {
            await axiosInstance.get('/checkAdmin', {withCredentials:true} )
            .then(response => {
                setAdmin(response.data.isAdmin)
            })
            .catch(error => {
                setAdmin(false)
                console.log(error)
            });
        };

        getInitialUserState();

        getAdminState();

        setLoading(false);

    }, [])

    return (
        <Router>
            <Navbar authenticatedUser={authenticatedUser} isAdmin={isAdmin} />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/search" element={<Search authenticatedUser={authenticatedUser} isLoading={isLoading} isAdmin={isAdmin} setAdmin={setAdmin}/>} />
                <Route path="/taxpayer" element={<Taxpayer authenticatedUser={authenticatedUser} isLoading={isLoading} isAdmin={isAdmin}/>} />
                <Route path="/twoFactor" element={<TwoFactor authenticatedUser={authenticatedUser} />} />
                
                <Route path="/previousClients" element={<PreviousClients authenticatedUser={authenticatedUser} isLoading={isLoading} setAdmin={setAdmin}/>} />
                <Route path="/admin" element={<Admin authenticatedUser={authenticatedUser} isAdmin={isAdmin} />} />
                <Route path="/login" element={<Login authenticatedUser={authenticatedUser} setAuthenticatedUser={setAuthenticatedUser} setAdmin={setAdmin}/>} />
                <Route path="/logout" element={<Logout authenticatedUser={authenticatedUser} setAuthenticatedUser={setAuthenticatedUser} setAdmin={setAdmin}/>} />
            </Routes>
        </Router>
    );
}
 
export default App;